import React from 'react';
import Dropdown from 'react-dropdown';

//animition for desktop
const Animation = [
  { value: 'fade', label: 'Fade' },
  { value: 'bounce', label: 'Bounce' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'zoom_in_down', label: 'Zoom In Down' },
  { value: 'slide', label: 'Slide' },
  { value: 'horizonatal_slide', label: 'Slide Horizontal' },
  { value: 'side_flip_in', label: 'Slide Flip In' },
  { value: 'side_flip_back', label: 'Slide Flip Back' },
  { value: 'flip', label: 'Flip' },
  { value: 'up_flip', label: 'Flip Up' },
  { value: 'back_flip', label: 'Flip Back' },
];

const Position = [
  { value: 'left_top', label: 'Left top' },
  { value: 'center_top', label: 'Center top' },
  { value: 'right_top', label: 'Right top' },
  { value: 'left_center', label: 'Left center' },
  { value: 'center', label: 'Center' },
  { value: 'right_center', label: 'Right center' },
  { value: 'left_bottom', label: 'Left bottom' },
  { value: 'center_bottom', label: 'Center bottom' },
  { value: 'right_bottom', label: 'Right bottom' }
];
const ToolAppearanceCard = ({
  cnf,
  handleCnfChange,
}) => {
  return (
    <div>
      <div className="card-editor-block p-0">
        <label className="card-editor-title">Position & Animation in  Desktop</label>
        <div className="customize-list">
          <div className="editor-toggle customize-dropdown customize-showarrow">
            <label className="label-title">Show</label>
            <label className="switch">
              <input type="checkbox" checked={cnf.isdsk} onChange={(e) => handleCnfChange('isdsk', e.target.checked)} />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="editor-dropdown customize-dropdown customize-coloms">
            <label>Animation</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.dskanm != undefined ? cnf.dskanm.toString() : cnf.dskanm} onChange={(e) => handleCnfChange('dskanm', e.value)} />
          </div>
          <div className="editor-dropdown customize-dropdown customize-coloms">
            <label>Position</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={cnf.dskpos != undefined ? cnf.dskpos.toString() : cnf.dskpos} onChange={(e) => handleCnfChange('dskpos', e.value)} />
          </div>
        </div>
      </div>
      <div className="card-editor-block p-0 mt-35">
        <label className="card-editor-title">Position & Animation in Mobile</label>
        <div className="customize-list">
          <div className="editor-toggle customize-dropdown customize-showarrow">
            <label className="label-title">Show</label>
            <label className="switch">
              <input type="checkbox" checked={cnf.ismbl} onChange={(e) => handleCnfChange('ismbl', e.target.checked)} />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="editor-dropdown customize-dropdown customize-coloms">
            <label>Animation</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.mblanm != undefined ? cnf.mblanm.toString() : cnf.mblanm} onChange={(e) => handleCnfChange('mblanm', e.value)} />
          </div>
          <div className="editor-dropdown customize-dropdown customize-coloms">
            <label>Position</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={cnf.mblpos != undefined ? cnf.mblpos.toString() : cnf.mblpos} onChange={(e) => handleCnfChange('mblpos', e.value)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolAppearanceCard;


// WEBPACK FOOTER //
// ./src/components/Widget/ToolAppearanceCard.js